"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const styled_1 = __importDefault(require("@emotion/styled"));
const _1 = require(".");
function default_1({ commentId, defaultValue = '', focusDep = false, secret = false, onCancel = () => { }, }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const whoAmI = (0, react_redux_1.useSelector)((state) => state.whoAmI);
    const nickname = whoAmI.is_logged_in ? whoAmI.nickname : t('문의는 로그인 후 작성할 수 있어요~');
    return ((0, jsx_runtime_1.jsxs)(CommentFormWrapper, { children: [(0, jsx_runtime_1.jsx)("h2", { children: nickname }), (0, jsx_runtime_1.jsx)(_1.CommentEditor, { commentId: commentId, defaultValue: defaultValue, focusDep: focusDep }), (0, jsx_runtime_1.jsx)(_1.CommentRegister, { commentId: commentId, defaultValue: defaultValue, secret: secret, onCancel: onCancel })] }));
}
exports.default = default_1;
const CommentFormWrapper = styled_1.default.div `
  h2 {
    font-size: 15px;
    font-weight: 700;
    padding-bottom: 8px;
  }
`;
